/**
 * Returns a copy of the list with one item moved.
 * @param {Array} items
 * @param {number} fromIndex - Where the item is now.
 * @param {number} toIndex - Where it should end up, counted after it is removed.
 * @returns {Array} The reordered copy, or `items` itself when the index does not change.
 */
export const moveItem = (items, fromIndex, toIndex) => {
  if (fromIndex === toIndex) return items;
  const next = [...items];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};
